import { Tooltip } from 'primeng/tooltip';
import { Ecotax } from '../configurators-2d/applications/decking-boards/ecotax';
import { Ean as BaseEan } from '../configurators-2d/resume/ean';

export class BasketProduct extends BaseEan {
  nameFr: string;
  nameEn: string;
  price: number;
  ean: string;

  bundleId?: string;
  bundleProducts: BasketProduct[] = [];

  get isBundle(): boolean {
    return this.bundleProducts?.length > 0;
  }

  iconId: number;

  toolTipId?: number;
  toolTip?: Tooltip;

  ecotaxId: number;
  ecotax: Ecotax;

  quantity: number;
  imgPath: string;
}
